import { makeObservable } from 'mobx';
import { AsyncState } from 'shared/libs/state';
import { ApiError } from 'shared/types';
import { CvCommentApiService } from './CvCommentApiService';

export class CvCommentStore {
   constructor() {
      makeObservable(this);
   }
   readonly addEmployerCommentState = new AsyncState<any>();
   readonly removeEmployerCommentState = new AsyncState<any>();

   async addEmployerComment(
      dto: { id: number | string; comment: string },
      { onSuccess, onError }: { onSuccess?: (res: any) => void; onError?: (e: string) => void } = {}
   ): Promise<void> {
      await this.addEmployerCommentState.run(
         () =>
            CvCommentApiService.addEmployerComment({
               id: dto.id,
               comment: dto.comment,
            }),
         {
            onSuccess: (res) => {
               if (res) {
                  onSuccess?.(res);
               }
            },
            onError: (e: ApiError) => {
               if (e.details?.error?.message === 'validation.max.string') {
                  onError?.('Mаксимальна довжина коментаря 250 символів');
               }
            },
            onFinally: () => {},
         }
      );
   }

   async removeEmployerComment(
      dto: { id: number | string },
      { onSuccess, onError }: { onSuccess?: (res: any) => void; onError?: (e: string) => void } = {}
   ): Promise<void> {
      await this.removeEmployerCommentState.run(
         () => CvCommentApiService.deleteEmployerComment({ id: dto.id }),
         {
            onSuccess: (res) => {
               if (res) {
                  onSuccess?.(res);
               }
            },
            onError: () => {},
            onFinally: () => {},
         }
      );
   }
}
